import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { Box } from '@mui/system';
import { ELEVATION } from '@openx/components-core/lib/theme/elevation.ts';

export const DirectDealsPublisherTilesLoading = () => {
  return (
    <Box
      data-test={'tile-view-container-loader'}
      sx={{
        paddingTop: 5,
        backgroundColor: 'background.grayLight',
      }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={5}
          sx={{
            padding: 5,
            paddingTop: 0,
            display: 'grid',

            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              md: 'repeat(3, 1fr)',
            },
          }}
        >
          {[...new Array(6)].map((_e, i) => (
            <Grid
              key={i}
              data-test={'publisher-tile'}
              sx={{
                // Ensure each card stretches to fill the row height
                display: 'flex',
                maxWidth: '100%',
                overflow: 'hidden',
                '& > .MuiCard-root': {
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                },
              }}
            >
              <Card
                sx={{
                  boxShadow: ELEVATION.elevation0,
                  height: '100%',
                }}
              >
                <CardContent
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    padding: 0,
                  }}
                >
                  <Box
                    sx={{
                      borderBottom: 1,
                      padding: 1,
                      paddingLeft: 2,
                      paddingRight: 2,
                      borderColor: 'divider',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: theme => theme.palette.background.boxLight,
                      aspectRatio: '16 / 9',
                    }}
                  />

                  <Box
                    sx={{
                      padding: 2,
                      paddingBottom: 0,
                      maxWidth: '100%',
                    }}
                  >
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="56px"
                      sx={{
                        mb: 2,
                      }}
                    />

                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height="44px"
                      sx={{
                        mb: 2,
                      }}
                    />

                    <Skeleton
                      variant="rectangular"
                      width="60%"
                      height="44px"
                      sx={{
                        mb: 1,
                      }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};
